<template>
  <UCEmptyList
    class="parts-no-items"
    :title="formattedInformationText"
  />
</template>

<script setup>
// @ts-check

import { computed } from 'vue';
import { useRepairParts } from '@/composables/useRepairParts';
import { HiDateTimeSupport } from '@/js/common/HIConversionSupport';
import { Tabs } from '@/js/enums/externalRepairParts';

import UCEmptyList from '@/components/common/UCEmptyList.vue';

const { currentTab, selectedDate } = useRepairParts();

/**
 * Formats date to the DD/MM/YYYY format.
 * @param {Date} date
 */
function formatDate(date) {
  return HiDateTimeSupport.FormatDateTime(date, 'DD/MM/YYYY');
}

/** A computed prop that returns the message to display for info */
const formattedInformationText = computed(() => {
  if (!selectedDate.value) {
    return '';
  }

  let formattedDate;
  const fromDate = formatDate(selectedDate.value.Init);

  if (selectedDate.value.Init.getTime() === selectedDate.value.End.getTime()) {
    formattedDate = fromDate;
  } else {
    const toDate = formatDate(selectedDate.value.End);
    formattedDate = `${fromDate} - ${toDate}`;
  }

  const pending = currentTab.value === Tabs.PENDING;

  return `No hay partes ${pending ? 'pendientes' : 'finalizados'} de ${formattedDate}`;
});
</script>

<style scoped lang="scss">
.parts-no-items {
  margin: 0;
  padding: 0;

  :deep(img) {
    display: none;
  }
}
</style>
